import React, { useState, useEffect } from 'react';
import axios from 'axios';

import Constants from '../Constants';

// A stored image, shown as a thumbnail. The image is fetched with the stored login token, since an img tag cannot
// send one, and shown from a blob url. Renders nothing without an image id, while loading, or when the image is
// not found.
function ScreenshotThumbnail({image_id, alt_text}){
	const [image_url, set_image_url] = useState(null);

	useEffect(()=>{
		let current_url = null;
		let cancelled = false;

		const load_image = async()=>{
			const stored_token = localStorage.getItem(Constants.TOKEN_NAME);
			if(!image_id || !stored_token){
				return;
			}

			try {
				const response = await axios.get(Constants.SERVER_URL + '/api/image/' + image_id, {
					headers: { Authorization: 'Bearer ' + stored_token },
					responseType: 'blob'
				});

				if(cancelled){
					return;
				}

				current_url = URL.createObjectURL(response.data);
				set_image_url(current_url);
			}
			catch (error) {
				// No image to show.
				set_image_url(null);
			}
		};

		set_image_url(null);
		load_image();

		return ()=>{
			cancelled = true;
			if(current_url){
				URL.revokeObjectURL(current_url);
			}
		};
	}, [image_id]);

	if(!image_url){
		return null;
	}

	return (
		<img className="screenshot-thumbnail" src={image_url} alt={alt_text}/>
	);
}

export default ScreenshotThumbnail;
